/*
 * @Author: shiao
 * @Date: 2020-11-17 13:53:26
 * @LastEditTime: 2020-12-23 17:16:33
 * @LastEditors: shiao
 * @Description: In User Settings Edit
 * @FilePath: \o2o-app\src\store\index.js
 */
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo: {
      "nickname": "",                //类型：String  必有字段  备注：昵称
      "user_id": "",                //类型：String  必有字段  备注：用户id
    },
    supplierWithdrawImg: {//供应方提现发票凭证
      'filelist': []
    }
  },
  mutations: {
    setState(state, data) {
      for (let i = 0; i < data.length; i++) {
        state[data[i].name] = data[i].value;
        // console.log(data[i].name,data[i].value)
      }
    },
  },
  actions: {
  },
  modules: {
  }
})
